export const name = 'CompScrollHandlerAspect'

export const defaultModel = {}

export const functionLibrary = {
    scrollToComp: (scrollSiteTo, getCompYPosition) => {
        scrollSiteTo(0, getCompYPosition())
    }
}
